import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const CustomField3 = {
  id: 'customField3',
  displayName: <FormattedMessage {...messages.customField3} />,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'CustomField3',
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
